
import moment from 'moment-timezone'
import Calendar from '../Calendar/Calendar.vue'
import EventCard from '../EventCard/EventCard.vue'
import GbAppButton from '../../../../components/AppButton/AppButton.vue'
import GbSkeletonLoading from '../../../../components/SkeletonLoading/SkeletonLoading.vue'
import EventCardSkeleton from '../EventCard/EventCardSkeleton.vue'
import { getTimezone } from '../../../utils/api'

export default {
  name: 'CalendarWidget',
  components: {
    EventCardSkeleton,
    GbSkeletonLoading,
    GbAppButton,
    EventCard,
    Calendar
  },

  data() {
    return {
      selectedDay: null,
      nearEvent: {},
      timeZoneFetched: false
    }
  },

  computed: {
    nearEventLoading() {
      return this.nearEvent?.isLoading
    },

    nearEventFormatDate() {
      return this.nearEvent?.date?.format('DD MMMM')
    },

    selectedDayDate() {
      return this.selectedDay?.totalDate?.format('D MMMM')
    },

    selectedDayEvents() {
      return this.selectedDay?.events || []
    },

    selectedDayHolidays() {
      return this.selectedDay?.holidays || null
    }
  },

  async mounted() {
    const { timeZone } = (await getTimezone()) || {}
    if (timeZone && Object.keys(timeZone)?.length) {
      moment.tz.setDefault(timeZone?.iana)
    }
    this.timeZoneFetched = true
  },

  methods: {
    selectDay(selectedDayData) {
      const { day, nearEvent } = selectedDayData
      if (nearEvent) {
        this.nearEvent = nearEvent
      }
      this.selectedDay = day
    },

    closeCalendarWidget(e) {
      e.preventDefault()
    }
  }
}
